import { AvailabilityDate } from "./AvailabilityDate";

export class Perspective {
  start!: AvailabilityDate;
  end!: AvailabilityDate;

  constructor() {
    this.start = new AvailabilityDate();
    this.end = new AvailabilityDate();
  }
}
